import React from "react";

const ChatLayout = ({ children }) => {
  return (
    <div className="w-full h-[700px] flex gap-6 overflow-hidden">
      {children}
    </div>
  );
};

export default ChatLayout;

// import React from "react";

// const ChatLayout = ({ children }) => {
//   return (
//     <div className="w-full min-h-[805px] h-full flex gap-6">
//       {children}
//     </div>
//   );
// };

// export default ChatLayout;
